import React from 'react'
import TransactionTableMain from '../../Components/Wallet/TransactionTable'

function Wallet() {
  return (
    <div className=''>
   <h1 className=' text-[#0A0F46] mb-4 font-[500]'>Filter Transactions</h1> 
   <TransactionTableMain/>
    </div>
  )
}

export default Wallet